<template>
  <div class="o-pagination">
    <span class="o-pagination__prev">
      <a v-if="value > 1" @click="previous">{{ $t('previous') }}</a>
    </span>

    <span class="o-pagination__numbers">
      <span
        v-for="(item, i) in items"
        :key="i"
      >
        <span v-if="item === '...'">{{ item }}</span>
        <a
          v-else
          :class="item === value && 'current'"
          @click="() => $emit('input', item)"
        >{{ item }}</a>
      </span>
    </span>

    <span class="o-pagination__after">
      <a v-if="value < length" @click="next">{{ $t('next') }}</a>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    totalVisible: {
      type: Number,
      required: false,
      default() { return 7; }
    },
    length: {
      type: Number,
      default: 0,
      validator: (val) => val % 1 === 0,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      maxButtons: 0,
      selected: null,
    }
  },
  computed: {
    items() {
      const { totalVisible, maxButtons, length, range, value,  } = this;
      if(totalVisible === 0) {
        return [];
      }
      const maxLength = Math.min(
        Math.max(0, totalVisible) || length,
        Math.max(0, maxButtons) || length,
        length
      )
      if (length <= maxLength) {
        return range(1, length)
      }
      const even = maxLength % 2 === 0 ? 1 : 0
      const left = Math.floor(maxLength / 2)
      const right = length - left + 1 + even
      if (value > left && value < right) {
        const start = value - left + 2
        const end = value + left - 2 - even

        return [1, '...', ...range(start, end), '...', length]
      } else if (value === left) {
        const end = value + left - 1 - even
        return [...range(1, end), '...', length]
      } else if (value === right) {
        const start = value - left + 1
        return [1, '...', ...range(start, length)]
      } else {
        return [
          ...range(1, left),
          '...',
          ...range(right, length),
        ]
      }
    }
  },
  methods: {
    init () {
      this.selected = null
      this.$nextTick(this.onResize)
      setTimeout(() => (this.selected = this.value), 100)
    },
    onResize () {
      const width = this.$el && this.$el.parentElement
        ? this.$el.parentElement.clientWidth
        : window.innerWidth
      this.maxButtons = Math.floor((width - 96) / 42)
    },
    next (e) {
      e.preventDefault()
      this.$emit('input', this.value + 1)
      this.$emit('next')
    },
    previous (e) {
      e.preventDefault()
      this.$emit('input', this.value - 1)
      this.$emit('previous')
    },
    range (from, to) {
      const range = []
      from = from > 0 ? from : 1
      for (let i = from; i <= to; i++) {
        range.push(i)
      }
      return range
    },
  },
  watch: {
    value () {
      this.init()
    },
  },
  mounted () {
    this.init()
  },
}
</script>